import ConfigLayout from './config-layout';
import LayoutContents from './layout-contents';

export { LayoutContents, ConfigLayout };
